import React, { useState, useEffect, useCallback } from "react";
import { Collapse, Tooltip } from "antd";
import { Modal } from "../../../helpers/commonUi";
import { useParams } from "react-router-dom";
import * as _ from "lodash";
import { useToast } from "../../../helpers/commonFunction";
import { ReactComponent as PlusIcon } from "../../../assets/svg/plus_btn.svg";
import { ReactComponent as MoreIcon } from "../../../assets/svg/more.svg";
import style from "./env.module.sass";
import { Http } from "../../../helpers/axois";
import classNames from "classnames";
import Environment from "./Environment";
import { EnvSelect } from "../../../helpers/RxServices";
import { ReactComponent as PolicyIcon } from "../../../assets/svg/policyIcon.svg";
import { ReactComponent as EditIcon } from "../../../assets/svg/editIcon.svg";
import { ReactComponent as Delete } from "../../../assets/svg/delete.svg";
import Style from "./view.module.sass";
import { useSelector } from 'react-redux'
import { AttachPolicies } from '../../apps/AttachPolicies'
import { defaultApiKey } from ".";

const { Panel } = Collapse;

const Sidemenu = (props: any) => {
  const params: any = useParams();
  const [count, setcount] = useState(0);
  const [list, setlist] = useState<any>();
  const [selectEnv, setSelectEnv] = useState();
  const [defaultActiveKey, setdefaultActiveKey] = useState<any>();
  const [visible, setvisible] = useState(false);
  const [envParams, setenvParams] = useState<any>({});
  const [editData, seteditData] = useState<any>();
  const { ErrorToast, SuccessToast, WarningToast } = useToast();
  const [deleteData, setDeleteData] = useState<any>();
  const [deletevisible, setDeletevisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [policyModalVisible, setPolicyModalVisible] = useState<boolean>(false);
  const [policyModalData, setPolicyModalData] = useState<any>({});
  const [popUpState, setPopUpState] = useState<any>({});

  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

  const canCreateEnv = orgPermissions.includes('env.Create')
  const canEditEnv = orgPermissions.includes('env.Edit')
  const canDeleteEnv = orgPermissions.includes('env.Delete')
  const canViewPolicy = orgPermissions.includes('policy.View')
  const canAttachPolicy = orgPermissions.includes('policy.Attach')
  const canRemovePolicy = orgPermissions.includes('policy.Remove')
  const canViewTeam = orgPermissions.includes('team.View')

  useEffect(() => {
    setLoading(false);
  }, [loading]);

  const popUpContent = (data: any) => {
    const canEditEnvLocal = data.permissions.includes('env.Edit')
    const canDeleteEnvLocal = data.permissions.includes('env.Delete')
    const canViewTeamLocal = data.permissions.includes('team.View')
    const canViewPolicyLocal = data.permissions.includes('policy.View')
    const canAttachPolicyLocal = data.permissions.includes('policy.Attach')
    const canRemovePolicyLocal = data.permissions.includes('policy.Remove')

    return (
      <div className={Style.popUpContainer}>
        <div
          data-test-id="environment"
          className={Style.popUpItem}
          onClick={(e) => {
            e.stopPropagation();
            if (canEditEnv || canEditEnvLocal) {
              EnvSelect.sendMessage({ type: "edit", data: data });
            } else {
              ErrorToast('You are not authorized to edit environments')
            }
            setPopUpState({
              [data.id]: false,
            });
          }}
        >
          <EditIcon height="14px" width="14px" />
          <span data-test-id="edit" className={Style.popUpItemText} style={{color: "#292d32"}}>Edit</span>
        </div>
        <div
          data-test-id="policy_env"
          className={Style.popUpItem}
          onClick={(e) => {
            e.stopPropagation();
            if ((canEditEnv || canEditEnvLocal) && (canViewTeam || canViewTeamLocal) && (canViewPolicy || canViewPolicyLocal) && (canAttachPolicy || canAttachPolicyLocal || canRemovePolicy || canRemovePolicyLocal)) {
              setPolicyModalData({
                orgId: data.orgId,
                envId: data.id,
                canAttach: canAttachPolicy || canAttachPolicyLocal,
                canRemove: canRemovePolicy || canRemovePolicyLocal
              })
              setPolicyModalVisible(true)
            } else {
              ErrorToast("You are not authorized to change policies of this environment")
            }
            setPopUpState({
              [data.id]: false,
            });
          }}
        >
          <PolicyIcon height="14px" width="14px" />
          <span className={Style.popUpItemText} style={{ color: "#292d32" }}>Policy</span>
        </div>
        <div
          data-test-id="auth_env"
          className={Style.popUpItem}
          onClick={(e) => {
            e.stopPropagation();
            if (canDeleteEnv || canDeleteEnvLocal) {
              EnvSelect.sendMessage({ type: "delete", data: data });
            } else {
              ErrorToast('You are not authorized to delete environments')
            }
            setPopUpState({
              [data.id]: false,
            });
          }}
        >
          <Delete height="14px" width="14px" />
          <span className={Style.popUpItemText} style={{ color: "#292d32" }}>Delete</span>
        </div>
      </div>
    );
  };

  const setLoadingSpin = props.setLoadingSpin;
  // get environments
  const getEnvs = useCallback(() => {
    Http.get(`org/${params.orgId}/environments`).subscribe((res: any) => {
      setLoadingSpin(false)
      if (res && res.length === 0) {
        setlist([])
        setdefaultActiveKey(null);
        EnvSelect.sendMessage({ type: "get", data: null });
        WarningToast("No environments available")
        // setvisible(true);
        return;
      }
      const grp: any = _.groupBy(res, "type");
      setlist(grp);
      let envStatus = "";
      setdefaultActiveKey(null);
      if (grp && grp.testing && grp.testing.length > 0) {
        envStatus = "testing";
      } else if (grp && grp.staging && grp.staging.length > 0) {
        envStatus = "staging";
      } else if (grp && grp.production && grp.production.length > 0) {
        envStatus = "production";
      } else {
        envStatus = "";
      }
      setdefaultActiveKey(envStatus);
      if (envStatus) {
        const select = grp[envStatus];
        if (select && select.length > 0) {
          const data = selectEnv ? select.find((env: any)=>  env.id === selectEnv) : select[0]
          selectEnvironment(data);
        }
      }
      setenvParams({
        apiKey: defaultApiKey,
      })
    }, (err: any) => {
      if (err === 'Forbidden') {
        props.setIsForbidden(true)
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, selectEnv]);
  // when delete the env reload the env and select new one
  useEffect(() => {
    if (count === 0) {
      EnvSelect.getMessage().subscribe((res) => {
        if (res.type === "delete") {

          setDeleteData(res.data);
          setDeletevisible(true);
          // deleteEnv(res.data)
          // getEnvs();
        }
        if (res.type === "edit") {
          seteditData(res.data);
          setvisible(true);
        }
      });
      getEnvs();
      setcount(1);
    }
  }, [count, getEnvs]);
  const deleteEnv = (dataToDelete: any) => {
    const arnName = `env:${dataToDelete.id}`
    Http.delete(`environments/${dataToDelete.id}?orgId=${dataToDelete.orgId}&arn=${arnName}`).subscribe(
      (res) => {
        SuccessToast("Environment delete successfully");
        getEnvs();
        setvisible(false);
      },
      () => {
        ErrorToast("Environment delete failed");
      }
    );
  };
  const selectEnvironment = (data: any) => {
    EnvSelect.sendMessage({ type: "get", data: data });
    setSelectEnv(data.id);
  };
  const setEnvParams = (key: string, value: any) => {
    setenvParams({
      ...envParams,
      [key]: value,
    });
  };

  const onEnvSubmit = () => {
    setLoading(true);
    const initialEditData = editData ? {
      name: editData.name,
      type: editData.type,
      appType: editData.appType,
      apiKey: editData.apiKey,
      url: editData.url,
    } : {}
    const data = {
      ...initialEditData,
      ...envParams,
      orgId: params.orgId,
    };

    if (!data.name || data.name.trim() === "") {
      ErrorToast("Environment Name can't be empty");
      return;
    }
    if (!data.type || data.type.trim() === "") {
      ErrorToast("Environment type can't be empty");
      return;
    }
    if (!data.apiKey || data.apiKey.trim() === "") {
      ErrorToast("API key can't be empty");
      return;
    }
    if (!data.url || data.url.trim() === "") {
      ErrorToast("Domain can't be empty");
      return;
    }

    const requestData = {...editData, ...data};
    if (requestData.apiKey === defaultApiKey) {
        delete requestData.apiKey;
    }

    if (editData) {
      const arnName = `env:${editData.id}`
      Http.put(`environments/${editData.id}?arn=${arnName}`, {
        ...requestData,
      }).subscribe(
        (res) => {
          SuccessToast("Environment updated successfully");
          getEnvs();
          setvisible(false);
          setLoading(false);
          seteditData(null)
          setenvParams({})
        },
        () => {
          ErrorToast("Environment updation failed");
          setLoading(false);
        }
      );
    } else {
      Http.post("environments", data).subscribe(
        (res) => {
          SuccessToast("Environment created successfully");
          getEnvs();
          setvisible(false);
          setLoading(false);
        },
        (e) => {
          ErrorToast((e && e.message) ? e.message : "Environment creation failed");
          setLoading(false);
        }
      );
    }
  };

  return (
    <React.Fragment>
      <div className={style.sidemenu}>
        <div className={style.header}>
          <h4>ENVIRONMENT</h4>
          {
            canCreateEnv
            &&
            <PlusIcon
              data-test-id="new_environment"
              width="24px"
              height="24px"
              style={{ cursor: "pointer", color: "#51808C" }}
              onClick={() => {
                seteditData(null);
                setvisible(true);
                setLoading(false);
              }}
            />
          }
        </div>
        <div className={style.panelDiv}>
          {defaultActiveKey && (
            <Collapse accordion defaultActiveKey={defaultActiveKey} expandIconPosition={"right"} className={style.Collapse}>
              <Panel data-test-id="testing" header="Testing" key="testing" className={style.panel + "  env-panel"}>
                <ul className={"list-group " + style.panelUl}>
                  {list &&
                    list.testing &&
                    list.testing.map((data: any, index: number) => {
                      return (
                        <li data-test-id={`${data.name}_env`} key={index} className={"list-group-item  " + classNames({ [style.active]: selectEnv === data.id })} onClick={() => selectEnvironment(data)}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <h4 style={{ color: "#51808C" }}>{data.name}</h4>
                            <Tooltip
                              onVisibleChange={(value) =>
                                setPopUpState({
                                  [data.id]: value,
                                })
                              }
                              visible={popUpState[data.id]}
                              placement="right"
                              overlayClassName="teamPopUp"
                              title={() => popUpContent(data)}
                              trigger="click"
                            >
                              <div data-test-id="more_icon" className={Style.envOptionButton} onClick={(e) => e.stopPropagation()}>
                                <MoreIcon height="10px" />
                              </div>
                            </Tooltip>
                          </div>
                        </li>
                      );
                    })}
                </ul>
              </Panel>
              <Panel data-test-id="staging" header="Staging" key="staging" className={style.panel + "  env-panel"}>
                <ul className={"list-group " + style.panelUl}>
                  {list &&
                    list.staging &&
                    list.staging.map((data: any, index: number) => {
                      return (
                        // <li className={"list-group-item  " + classNames({ [style.active]: selectEnv === data.id })} key={index} onClick={() => selectEnvironment(data)}>
                        //     <h4>{data.name}</h4>
                        // </li>
                        <li data-test-id={`${data.name}_env`} key={index} className={"list-group-item  " + classNames({ [style.active]: selectEnv === data.id })} onClick={() => selectEnvironment(data)}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <h4 style={{ color: "#51808C" }}>{data.name}</h4>
                            <Tooltip
                              onVisibleChange={(value) =>
                                setPopUpState({
                                  [data.id]: value,
                                })
                              }
                              visible={popUpState[data.id]}
                              placement="right"
                              overlayClassName="teamPopUp"
                              title={() => popUpContent(data)}
                              trigger="click"
                            >
                              <div data-test-id="more_icon" className={Style.envOptionButton} onClick={(e) => e.stopPropagation()}>
                                <MoreIcon height="10px" />
                              </div>
                            </Tooltip>
                          </div>
                        </li>
                      );
                    })}
                </ul>
              </Panel>
              <Panel data-test-id="production" header="Production" key="production" className={style.panel + " env-panel"}>
                <ul className={"list-group " + style.panelUl}>
                  {list &&
                    list.production &&
                    list.production.map((data: any, index: number) => {
                      return (
                        // <li className={"list-group-item  " + classNames({ [style.active]: selectEnv === data.id })} key={index} onClick={() => selectEnvironment(data)}>
                        //     <h4>{data.name}</h4>
                        // </li>
                        <li
                          // onContextMenu={(e) => {
                          //     e.preventDefault()
                          //     setPopUpState({
                          //         [data.id] : true
                          //     })
                          // }}
                          key={index}
                          data-test-id={`${data.name}`}
                          className={"list-group-item  " + classNames({ [style.active]: selectEnv === data.id })}
                          onClick={() => selectEnvironment(data)}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <h4 style={{ color: "#51808C" }}>{data.name}</h4>
                            <Tooltip
                              onVisibleChange={(value) =>
                                setPopUpState({
                                  [data.id]: value,
                                })
                              }
                              visible={popUpState[data.id]}
                              placement="right"
                              overlayClassName="teamPopUp"
                              title={() => popUpContent(data)}
                              trigger="click"
                            >
                              <div data-test-id="more_icon" className={Style.envOptionButton} onClick={(e) => e.stopPropagation()}>
                                <MoreIcon height="10px" />
                              </div>
                            </Tooltip>
                          </div>
                        </li>
                      );
                    })}
                </ul>
              </Panel>
            </Collapse>
          )}
        </div>
      </div>
      <Modal
        dataTestId="env_modal"
        id="env modal"
        title={editData ? "EDIT ENVIRONMENT" : "CREATE ENVIRONMENT"}
        onCancel={() => {
          setvisible(false);
        }}
        unmountOnCancel={true}
        footer={{
          enable: true,
          okText: editData ? "UPDATE" : "CREATE",
          cancelText: "CANCEL",
          onOk: () => onEnvSubmit(),
        }}
        visible={visible}
        loading={loading}
      >
        <Environment data-test-id="environment" setEnvParams={setEnvParams} editData={editData} />
      </Modal>
      <Modal
        id="deleteEnv"
        dataTestId="delete_env"
        unmountOnCancel={true}
        visible={deletevisible}
        title="DELETE ENVIRONMENT"
        onCancel={() => {
          setDeletevisible(false);
          setDeleteData({});
        }}
        deleteOptions={{
          type: "App",
          validateString: deleteData && deleteData.name,
        }}
        footer={{
          enable: true,
          okText: "DELETE",
          cancelText: "CANCEL",
          onOk: () => {
            deleteEnv(deleteData);
            setDeletevisible(false);
            setDeleteData({});
          },
        }}
      />
      <Modal
        width="650px"
        id="attachAppPolicies"
        dataTestId="attach_app_policies"
        unmountOnCancel={true}
        visible={policyModalVisible}
        title="ATTACH POLICIES"
        onCancel={() => {
          setPolicyModalVisible(false)
          setPolicyModalData({})
        }}
        footer={{
          enable: false
        }}
      >
        <AttachPolicies data={policyModalData} />
      </Modal>
    </React.Fragment>
  );
};

export default Sidemenu;
